import React, { FC, useEffect, useState } from "react";

import {
  Box,
  IconButton,
  TextField,
  Typography,
  Button,
  Card,
  CardActionArea,
  Switch,
  FormGroup,
  MenuItem,
} from "@mui/material";
import styles from "./QuestionsToInterview.module.scss";
import Menu from "@mui/material/Menu";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";

import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";
import MarkUnreadChatAltRoundedIcon from "@mui/icons-material/MarkUnreadChatAltRounded";
import { IQuestion } from "../../models/IQuestion";
import truncateWords from "../../utils/TruncateWords";

const CreateQuestions = ({
  questions,
  setSelectedCard,
  selectedCard,
  setQuestions,
  setAnchorEl,
  setSelectedCardRemove,
  anchorEl,
  openMenu,
  setOpenDialogConfirmation,
  welcomeTitle,
  setWelcomeTitle,
  welcomeMessage,
  setWelcomeMessage,
  setOpenMessage,
  setShowMessage,
  newQuestionText,
  interviewId,
  isMandatory,
  newQuestionContext,
  setIsMandatory,
  setNewQuestionText,
  setNewQuestionContext,
  completedTitle,
  completedMessage,
  checkedCcustom,
  setCheckedCcustom,
  setCompletedTitle,
  setCompletedMessage,
  setQuestionText,
  questiontext,
  setQuestionContext,
  questionContext,
  setNewIsMandatory,
  newIsMandatory,
  newInterview,
}: any) => {
  const { t } = useTranslation();

  // step2: order questions
  const handleDragEnd = (result: any) => {
    if (!result.destination) return; // No cambio de posición

    const updatedQuestions = [...questions];
    const [reorderedItem] = updatedQuestions.splice(result.source.index, 1);
    updatedQuestions.splice(result.destination.index, 0, reorderedItem);

    // Actualizar el orden de cada pregunta
    const reorderedWithOrder = updatedQuestions.map((q, index) => ({
      ...q,
      order: index + 1,
    }));

    setQuestions(reorderedWithOrder);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // step2: add questions
  const addQuestion = () => {
    setSelectedCard(
      questions.reduce(
        (max: number, item: IQuestion) => (item.Id > max ? item.Id : max),
        0
      ) + 1
    );

    setQuestions(questions);
  };

  //step2: save edited question
  const handleSaveEditedQuestion = () => {
    setSelectedCard(null);
    setOpenMessage(true);
    setShowMessage({ message: "Your question was updated!", label: "success" });
  };

  const handleSaveAndAddEditedQuestion =()=>{
    handleSaveEditedQuestion()
    addQuestion()
  }

  //step2 save new question
  const saveNewQuestion = () => {

    if (questiontext.trim()) {
      setQuestions((prevstate: any) => [
        ...prevstate,
        {
          Id:
            questions.reduce(
              (max: number, item: IQuestion) => (item.Id > max ? item.Id : max),
              0
            ) + 1,
          InterviewId: parseInt(interviewId || newInterview.Id || "0"),
          QuestionText: questiontext,
          QuestionOrder: prevstate.length + 1,
          IsRequired: newIsMandatory,
          Context: questionContext,
        },
      ]);

      setQuestionText("");
      setQuestionContext("");
      setNewIsMandatory(false);
      setSelectedCard(null);
      setOpenMessage(true);
      setShowMessage({
        message: "Your question was created!",
        label: "success",
      });
    }
  };

  const saveNewAddQuestion = () => {
 
    if (questiontext.trim()) {
      setQuestions((prevstate: any) => [
        ...prevstate,
        {
          Id:
            questions.reduce(
              (max: number, item: IQuestion) => (item.Id > max ? item.Id : max),
              0
            ) + 1,
          InterviewId: parseInt(interviewId || newInterview.Id || "0"),
          QuestionText: questiontext,
          QuestionOrder: prevstate.length + 1,
          IsRequired: newIsMandatory,
          Context: questionContext,
        },
      ]);
    
      setQuestionText("");
      setQuestionContext("");
      setNewIsMandatory(false);

      setSelectedCard(
        questions.reduce(
          (max: number, item: IQuestion) => (item.Id > max ? item.Id : max),
          0
        ) + 2
      );

      setOpenMessage(true);
      setShowMessage({
        message: "Your question was created! add new one",
        label: "success",
      });
    }
  };
  return (
    <div className={styles.questions}>
      <div style={{ width: "40%" }}>
        {/*   <h4 style={{ marginTop: "50px", marginBottom: "-20px" }}>General Description</h4> */}
        <Typography variant="h6" className={styles.title}>
          {t("general.admin.questions")}
        </Typography>
        <p>Total: {questions.length} questions</p>
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gap: 2,
          }}
        >
          <Card key={100000000}>
            <CardActionArea
              onClick={() => setSelectedCard(100000000)}
              data-active={selectedCard === 100000000 ? "" : undefined}
              sx={{
                height: "100%",
                border: "1px solid #77a2d3",
                "&[data-active]": {
                  backgroundColor: "action.selected",
                  "&:hover": {
                    backgroundColor: "action.selectedHover",
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  width: "100%",
                  alignItems: "center",
                  gap: 2,
                  padding: "6px",
                }}
              >
                {/* <LogoutIcon /> */} {/* Your icon */}
                <div
                  style={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <MarkUnreadChatAltRoundedIcon />
                  <div style={{ marginLeft: "6px" }}>
                    <Typography variant="body2" component="div">
                      {"Hello"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {"Home Screen"}
                    </Typography>
                  </div>
                </div>
              </Box>
            </CardActionArea>
          </Card>
     
           <div className={styles.column}>
            <Box className={styles.questionContainer}>
              <Button
                variant="contained"
                size="small"
                style={{
                  padding:"10px",
                  margin:"0px"
                }}
                onClick={addQuestion}
              >
                {t("general.admin.addQuestion")}
              </Button>
            </Box>
          </div>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="questionsList">
              {(provided: any) => (
                <Box
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  sx={{
                    width: "100%",
                    margin: "auto",
                    position: "relative",
                  }}
                >
                  {questions.map((question: IQuestion, index: number) => (
                    <Draggable
                      key={question.Id}
                      draggableId={question.Id.toString()}
                      index={index}
                    >
                      {(provided: any, snapshot: any) => (
                        <Card
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          key={index}
                          onClick={() => setSelectedCard(question.Id)}
                          data-active={
                            selectedCard === question.Id ? "" : undefined
                          }
                          sx={{
                            position: "relative", // Ensure relative position for stacking
                            height: "100%",
                            border: "1px solid #77a2d3",
                            "&[data-active]": {
                              backgroundColor: "action.selected",

                              "&:hover": {
                                backgroundColor: "action.selectedHover",
                              },
                            },
                            marginBottom: 2,
                            padding: 1,
                            boxShadow: snapshot.isDragging ? 6 : 2,
                            backgroundColor: snapshot.isDragging
                              ? "#f0f0f0"
                              : "white",
                            transition: "background-color 0.2s",
                            cursor: "grab",
                          }}
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              zIndex: 10,
                            }}
                          >
                            <IconButton
                              onClick={(event) => {
                                event.stopPropagation();
                                setAnchorEl(event.currentTarget);
                                setSelectedCardRemove(question.Id);
                              }}
                              sx={{
                                zIndex: 10000,
                                backgroundColor: "transparent",
                              }}
                              size="small"
                              color="inherit"
                            >
                              <MoreVertRoundedIcon />
                            </IconButton>
                            <Menu
                              id="basic-menu"
                              anchorEl={anchorEl}
                              open={openMenu}
                              onClose={handleClose}
                              MenuListProps={{
                                "aria-labelledby": "basic-button",
                              }}
                            >
                              <MenuItem
                                onClick={() => {
                                  setOpenDialogConfirmation(true);
                                  setAnchorEl(null);
                                }}
                              >
                                <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
                                Remove
                              </MenuItem>
                            </Menu>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              height: "100%",
                              width: "100%",
                              alignItems: "center",
                              gap: 2,
                              padding: "6px",
                            }}
                          >
                            {/* <LogoutIcon /> */} {/* Your icon */}
                            <div
                              style={{
                                display: "flex",
                                alignContent: "center",
                                alignItems: "center",
                                marginRight: "10px",
                              }}
                            >
                              <ArticleRoundedIcon />
                              <div style={{ marginLeft: "6px" }}>
                                <Typography variant="body2" component="div">
                                  {question.QuestionText}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                   {truncateWords(question.Context || '', 4)}
                                </Typography>
                              </div>
                            </div>
                          </Box>
                        </Card>
                      )}
                    </Draggable>
                  ))}

                  {provided.placeholder}
                </Box>
              )}
            </Droppable>
          </DragDropContext>

         
          <Card key={100000002}>
            <CardActionArea
              onClick={() => setSelectedCard(100000002)}
              data-active={selectedCard === 100000002 ? "" : undefined}
              sx={{
                height: "100%",
                border: "1px solid #77a2d3",
                "&[data-active]": {
                  backgroundColor: "action.selected",

                  "&:hover": {
                    backgroundColor: "action.selectedHover",
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  height: "100%",
                  width: "100%",
                  alignItems: "center",
                  gap: 2,
                  padding: "6px",
                }}
              >
                {/* <LogoutIcon /> */} {/* Your icon */}
                <div
                  style={{
                    display: "flex",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <MarkUnreadChatAltRoundedIcon />
                  <div style={{ marginLeft: "6px" }}>
                    <Typography variant="body2" component="div">
                      {"Thank you!"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {"Thank you screen"}
                    </Typography>
                  </div>
                </div>
              </Box>
            </CardActionArea>
          </Card>
        </Box>
      </div>
      <div style={{ width: "60%", padding: "40px" }}>
        {selectedCard === 100000000 && (
          <div className={styles.createInterview}>
            <h2>Welcome Screen</h2>
            <p
              style={{
                marginTop: "-20px",
                fontSize: "10px",
                fontStyle: "oblique",
              }}
            >
              We encourage you to custom the title and message
            </p>
            <TextField
              label={"Title"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={welcomeTitle}
              onChange={(e) => setWelcomeTitle(e.target.value)}
            />
            <TextField
              label={"Message"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={welcomeMessage}
              onChange={(e) => setWelcomeMessage(e.target.value)}
            />
          </div>
        )}
        {questions.map(
          (question: IQuestion, index: number) =>
            question.Id === selectedCard && (
              <div className={styles.createInterview} key={question.Id}>
                <h2>{"Question"}</h2>
                <TextField
                  multiline
                  label={"Question"}
                  variant="standard"
                  fullWidth
                  margin="normal"
                  className={styles.textField}
                  value={question.QuestionText}
                  onChange={(e) =>
                    setQuestions((prevQuestions: IQuestion[]) =>
                      prevQuestions.map((q: IQuestion) =>
                        q.Id === question.Id
                          ? { ...q, QuestionText: e.target.value }
                          : q
                      )
                    )
                  }
                />
                <TextField
                  multiline
                  label={"Context of the question"}
                  variant="standard"
                  fullWidth
                  margin="normal"
                  className={styles.textField}
                  value={question.Context}
                  onChange={(e) =>
                    setQuestions((prevQuestions: IQuestion[]) =>
                      prevQuestions.map((q: IQuestion) =>
                        q.Id === question.Id
                          ? { ...q, Context: e.target.value }
                          : q
                      )
                    )
                  }
                />
                <FormGroup
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "40px",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ marginLeft: "6px" }}>
                    <Typography variant="body2" component="div">
                      {"Required"}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {"Required question"}
                    </Typography>
                  </div>
                  <Switch
                    onChange={(e) =>
                      setQuestions((prevQuestions: IQuestion[]) =>
                        prevQuestions.map((q) =>
                          q.Id === question.Id
                            ? { ...q, IsRequired: e.target.checked }
                            : q
                        )
                      )
                    }
                    checked={question.IsRequired}
                  />
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "24px",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => setSelectedCard(null)}
                  >
                    Cancel
                  </Button>

                  <Button
                    variant="contained"
                    onClick={() => handleSaveEditedQuestion()}
                  >
                    Save
                  </Button>
                  <Button
                    style={{ padding: "6px" }}
                    variant="contained"
                    onClick={() => handleSaveAndAddEditedQuestion()}
                  >
                    Save & Add another
                  </Button>
                </div>
              </div>
            )
        )}
        {selectedCard ===
          questions.reduce(
            (max: number, item: IQuestion) => (item.Id > max ? item.Id : max),
            0
          ) +
            1 && (
          <div className={styles.createInterview}>
            <h2>Question</h2>
            <TextField
              label={"Question"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={questiontext}
              onChange={(e) => setQuestionText(e.target.value)}
            />
            <TextField
              label={"Context"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={questionContext}
              onChange={(e) => setQuestionContext(e.target.value)}
            />
            <FormGroup
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "40px",
                justifyContent: "space-between",
              }}
            >
              <div style={{ marginLeft: "6px" }}>
                <Typography variant="body2" component="div">
                  {"Required"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {"Required question"}
                </Typography>
              </div>
              <Switch
                checked={newIsMandatory}
                onChange={(e) => setNewIsMandatory(e.target.checked)}
              />
            </FormGroup>
            <div
              style={{
                display: "flex",
                padding: "9px",
                justifyContent: "center",
                marginTop: "24px",
              }}
            >
              <Button variant="outlined" onClick={() => setSelectedCard(null)}>
                Cancel
              </Button>

              <Button variant="contained" onClick={saveNewQuestion}>
                Save
              </Button>
              <Button style={{padding:"6px"}} variant="contained" onClick={saveNewAddQuestion}>
                Save & Add another
              </Button>
            </div>
          </div>
        )}
        {selectedCard === 100000001 && <></>}
        {selectedCard === 100000002 && (
          <div className={styles.createInterview}>
            <h2>Thank you Screen</h2>
            <p
              style={{
                marginTop: "-20px",
                fontSize: "10px",
                fontStyle: "oblique",
              }}
            >
              We encourage you to custom the title and message
            </p>
            <TextField
              label={"Title"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={completedTitle}
              onChange={(e) => setCompletedTitle(e.target.value)}
            />
            <TextField
              label={"Message"}
              variant="standard"
              fullWidth
              margin="normal"
              className={styles.textField}
              value={completedMessage}
              onChange={(e) => setCompletedMessage(e.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateQuestions;
